import { CurrencyEnum } from "@lib/types/Transaction";
import * as yup from "yup";

export const manualTransactionSchema = yup.object().shape({
  amount: yup.number().min(1),
  currency: yup.string().required().oneOf(Object.values(CurrencyEnum)),
  description: yup.string().nullable(),
  customerId: yup.string().uuid(),
  invoiceId: yup.string().uuid().nullable(),
});
